// extracted by mini-css-extract-plugin
export var buttons = "_b9-0";
export var buttonsActive = "_b9-h";
export var cancelConfirm = "_b9-1";
export var closeButton = "_b9-2";
export var column = "_b9-3";
export var container = "_b9-4";
export var detailHeader = "_b9-6";
export var detailTitle = "_b9-7";
export var detailsContent = "_b9-5";
export var header = "_b9-8";
export var headerWithClose = "_b9-9";
export var icon = "_b9-a";
export var infoIcon = "_b9-c";
export var informationContainer = "_b9-b";
export var sideDrawer = "_b9-d";
export var sideDrawerOpen = "_b9-e";
export var stickyFooter = "_b9-f";
export var typeOption = "_b9-g";